import { matchPath } from 'react-router-dom';
import { SALESFORCE_AUTH_ROUTE } from '~/_shared/constants/routes';

export const isSalesforceAuthRoute = (pathname: string): boolean => {
  return !!matchPath({ path: SALESFORCE_AUTH_ROUTE, end: false }, pathname);
};

export const getSalesforceUserManagementUrl = (salesforceInstanceUrl: string): string => {
  const separator = salesforceInstanceUrl.endsWith('/') ? '' : '/';
  return `${salesforceInstanceUrl}${separator}lightning/n/Maptive__Configuration?c__selectedMenuItem=userManagement`;
};
